// 平台随访-用药计划
import { handlePlanType, filterTime } from '@/utils'

const BASE_LABEL = [
  {
    label: '随访ID: ',
    prop: 'followupPlanId',
    nopadding: true
  },
  {
    label: '医生ID: ',
    prop: 'doctorId'
  },
  {
    label: '医生姓名: ',
    prop: 'doctorName',
    noborder: true
  },
  {
    label: '随访状态: ',
    prop: 'planStatus',
    nopadding: true
  },
  {
    label: '患者ID: ',
    prop: 'patientProfileCommonVO',
    render: text => text?.patientProfileId || '--'
  },
  {
    label: '患者姓名: ',
    prop: 'patientProfileCommonVO',
    noborder: true,
    render: text => text?.patientProfileName || '--'
  },
  {
    label: '用药周期: ',
    prop: 'medicationCycle',
    nopadding: true,
    render: it => {
      if (it) {
        return it + '天'
      }
      return '--'
    }
  },
  {
    label: '关联处方: ',
    prop: 'relevancyPrescriptions',
    class: 'large',
    noborder: true
  },
  {
    label: '开始时间: ',
    prop: 'beginTime',
    nopadding: true,
    render: it => filterTime({ text: it })
  },
  {
    label: '结束时间: ',
    prop: 'endTime',
    render: it => filterTime({ text: it })
  },
  {
    label: '随访类型: ',
    prop: 'planType',
    noborder: true,
    render: it => handlePlanType(it)
  }
]
// 随访阶段
const visitDateColumn = [
  {
    title: '随访阶段',
    dataIndex: 'stageName',
    key: 'stageName',
    customRender: ({ text }) => {
      return text || '--'
    }
  },
  {
    title: '随访时间',
    dataIndex: 'followDate',
    key: 'followDate',
    width: 180,
    customRender: ({ text }) => {
      return text || '--'
    }
  },
  {
    title: '推送状态',
    dataIndex: 'pushStatus',
    key: 'pushStatus',
    customRender: ({ text }) => {
      return text || '--'
    }
  },
  {
    title: '随访结果',
    dataIndex: 'followResult',
    key: 'followResult',
    customRender: ({ text }) => {
      return text || '--'
    }
  },
  {
    title: '评价人',
    dataIndex: 'flowEditName',
    key: 'flowEditName',
    width: 140,
    slots: { customRender: 'flowEditName' }
  },
  {
    title: '评价时间',
    dataIndex: 'cardEvaluateTime',
    key: 'cardEvaluateTime',
    customRender: ({ text }) => {
      return text || '--'
    }
  }
  // {
  //   title: '工单ID',
  //   dataIndex: 'workOrderId',
  //   key: 'workOrderId',
  //   customRender: ({ text }) => {
  //     return text || '--'
  //   }
  // }
  // {
  //   title: '操作',
  //   dataIndex: 'operation',
  //   key: 'operation',
  //   slots: { customRender: 'operation' }
  // }
]
export default {
  BASE_LABEL,
  visitDateColumn
}
